import React, { useState } from 'react';
import { Portal } from '~/components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import Modal from '~/components/Modal';
import {  MdClose } from 'react-icons/md';
import { searchSytemApi } from '~/api';
import { asyncState, } from '~/hooks';

const DeleteSystemSearch = (props) => {
    const [status, setStatus] = useState(asyncState.IDLE);

    const deleteSystem = async() => {
        try {
            setStatus(asyncState.PENDING);
            await searchSytemApi.deleteSystemSearch(props.id);
            setStatus(asyncState.SUCCESS);
            location.reload();
        }
        catch(err) {
            console.error(err);
            setStatus(asyncState.ERROR);
        }
    };

    return (
        <>
            {(status == asyncState.IDLE || status == asyncState.ERROR) &&
            <Modal isModalOpen={props.filtersOpen} preventScroll className='rounded-md bg-white'>
                <section className='w-full h-full flex flex-col items-stretch justify-start'>
                    <header className="border-b-2 text-md flex items-center justify-between py-2 px-6">
                        <p className="font-semibold">Delete</p>  
                        <button 
                            className="py-2 rounded-full"
                            onClick={props.filtersClose}
                        >
                            <MdClose size="1em" />
                        </button>
                        {status == asyncState.PENDING && (
                            <Portal id="loading-modal">
                                <div className="flex items-center justify-center h-screen w-screen bg-gray-400 opacity-70 z-50 fixed top-0 left-0 translate-y-1/2 -translate-x-1/2">
                                    <AiOutlineLoading3Quarters className="animate-spin text-blue-30 font-bold" size="4rem" />
                                </div>
                            </Portal>
                        )}
                    </header> 
                    <>
                        <div className="py-4 px-6 col-span-11 items-center">
                            <p className="w-64">
                                Are you sure you want to delete this system
                                <span className="font-bold"> {props.systemSearchName}</span>?
                            </p>
                        </div>
                        <div className='col-span-11 flex items-center justify-end text-xs mb-4 mr-6'>
                            <button 
                                className='py-2 px-4 rounded-full border mr-2 focus:outline-none'
                                onClick={props.filtersClose}
                            >
                                Cancel
                            </button>
                            <button 
                                className='py-2 px-4 rounded-full bg-red-600 text-white focus:outline-none'
                                onClick={deleteSystem}
                            >
                                Delete
                            </button>
                        </div> 
                    </>
                </section>
            </Modal>
            }
        </>
    );
};

export default DeleteSystemSearch;